/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.themes.donation.modals.editValue.controllers', [])

.controller('ThemesDonationModalsEditValueController', [
  '$scope', '$uibModalInstance',
  'themeItem',
  function(
    $scope, $uibModalInstance,
    themeItem
  ) {

    $scope.themesDonationModalsEditValue = {

      model: {
        textVariable: '',
        description: '',
        label: '',
        allowMarkup:false,
        customValue:'',
        themeValue:'',
        enabled: false
      },

      init: function() {
        this.setModel();
      },

      setModel: function() {
        this.model = Object.assign(this.model,themeItem);
        
        if (this.model.enabled === 'false') {
          this.model.enabled = false;
        }
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        themeItem.customValue = this.model.customValue;
        themeItem.enabled = this.model.enabled;

        $uibModalInstance.close(this.model);
      }

    };

    $scope.themesDonationModalsEditValue.init();

}]);
